/*
 * Copyright (c) Arc XP 2025.
 */

/**
 * A singleton event bus built upon EventTarget, allowing communication through events in a
 * centralized manner.
 */
export class KoiEventBus extends EventTarget {
  private static instance: KoiEventBus;

  private constructor() {
    super();
  }

  /**
   * Provides a singleton instance of the KoiEventBus class. Ensures that only one instance of
   * KoiEventBus is created and reused.
   *
   * @returns The singleton instance of the KoiEventBus.
   */
  public static getInstance(): KoiEventBus {
    if (!KoiEventBus.instance) {
      KoiEventBus.instance = new KoiEventBus();
    }
    return KoiEventBus.instance;
  }

  /**
   * Dispatches an event to all listeners.
   *
   * @param event - The event to dispatch.
   */
  public dispatchEvent(event: Event): boolean {
    return super.dispatchEvent(event);
  }
}
